import React from "react";
import {
  DialogTitle,
  DialogContent,
} from "@mui/material";
import UpdateUserForm from '../../../auth/RegisterUser/UpdateUserForm';
import CustomDialog from "../../../common/components/CustomDialog";

export default function UpdateClinicUserDialog({
  open,
  onClose,
  updateRole = false,
  userUuid = null,
  clinicId
}) {
  return (
    <CustomDialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>
        Update User
      </DialogTitle>

      <DialogContent dividers>
        <UpdateUserForm
          updateRole={updateRole}
          userUuid={userUuid}
          onClose={onClose}
          clinicId={clinicId}
        />
      </DialogContent>
    </CustomDialog>
  );
}
